import { COUNTRIES_API_PROVIDE } from 'store/address/reducer';
import axiosClient from 'utils/axios';

export default {
  async getAddress({
    countries = COUNTRIES_API_PROVIDE.VIETNAM,
    provinces = undefined,
    districts = undefined,
  }) {
    const path = '/address';

    const response = await axiosClient.get(path, {
      params: {
        countries,
        provinces,
        districts,
      },
    });

    return response.data;
  },
};
